import { Component, Input } from '@angular/core';
import { MediaTranscoderPackagerViewModel } from '../packager.view-model';

@Component({
  selector: 'evrideo-shaka-packager-job-report',
  templateUrl: './shaka-packager-job-report.component.html',
  styleUrls: ['./shaka-packager-job-report.component.scss'],
})
export class ShakaPackagerJobReportComponent {
  @Input()
  vm: MediaTranscoderPackagerViewModel;

  @Input()
  loadingMessage =
    'Retrieving Shaka Packager process log. Please wait.';
}
